import { render } from "./OidoButton.vue?vue&type=template&id=2da06c32&scoped=true"
import script from "./OidoButton.vue?vue&type=script&lang=js"
export * from "./OidoButton.vue?vue&type=script&lang=js"

import "./OidoButton.vue?vue&type=style&index=0&id=2da06c32&scoped=true&lang=css"
import "./OidoButton.vue?vue&type=style&index=1&id=2da06c32&lang=css"
import "./OidoButton.vue?vue&type=style&index=2&id=2da06c32&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da06c32"]])

export default __exports__